import type { MediaItem } from "@/types";

export const mediaItems: MediaItem[] = [
  {
    id: "movie-interstellar-dawn",
    title: "星际迷航：新纪元",
    category: "movie",
    region: "欧美",
    year: 2026,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20facing%20a%20giant%20glowing%20planet%2C%20deep%20navy%20blue%20and%20warm%20amber%20light%2C%20dramatic%20volumetric%20nebula%2C%20minimalist%20premium%20editorial%20art%2C%20high%20contrast%2C%20no%20text&width=600&height=900&seq=mock-movie-01&orientation=portrait",
    summary:
      "人类首次跨星系远航启程，一支临时组建的精英船队在未知星域面对文明存亡的抉择，宏大视效与人性拷问交织。",
    content: [
      "作为本年最受期待的科幻巨制，《星际迷航：新纪元》把镜头对准了人类历史上第一次跨星系远航。影片开场以一段近乎默片的宇宙长镜，把观众带进冰冷而壮阔的深空。",
      "导演在访谈中提到，团队花了三年时间为影片构建完整的世界观：从飞船的动力系统到星际文明的礼仪规范，每一处细节都经过推演。这让整部作品在视觉奇观之外，多了一层可信的质感。",
      "影片真正打动人的，并不是特效场面，而是船队在面临抉择时展现的犹豫与勇气。当个人生存与文明延续发生冲突，角色们给出了各自的答案，也让观众在离场后仍反复回味。",
    ],
    director: "亚瑟·雷诺兹",
    cast: ["伊森·克拉克", "莉莉·安德森", "陈浩宇"],
    releaseDate: "2026-06-12",
    views: 128600,
    rating: 9.1,
    tags: ["科幻", "太空", "史诗"],
    isFeatured: true,
  },
  {
    id: "tv-changan-night",
    title: "长安夜未央",
    category: "tv",
    region: "国内",
    year: 2026,
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20poster%20at%20night%2C%20lantern%20glow%2C%20traditional%20rooftops%20silhouette%2C%20deep%20indigo%20sky%20with%20warm%20gold%20light%2C%20elegant%20cinematic%20composition%2C%20refined%20editorial%20art%2C%20no%20text&width=600&height=900&seq=mock-tv-01&orientation=portrait",
    summary:
      "以一桩悬案为线索，揭开盛唐长安城表象之下的权力暗流，服化道考究，群像塑造细腻抓人。",
    content: [
      "《长安夜未央》把故事放在灯火通明的长安城。编剧没有急着铺陈案件，而是先花两集时间让观众熟悉这座城市与其中的人，再逐步收紧节奏。",
      "本剧最大亮点在于群像。每一个配角都有自己的动机与困境，没有纯粹的工具人。演员的表演克制而准确地传递出人物在时代洪流中的无力与坚持。",
      "美术团队参考了大量唐代壁画与器物资料，从街市招牌到室内陈设都力求还原。观众往往因为在某个画面里认出一件文物般的道具而会心一笑。",
    ],
    director: "苏文清",
    cast: ["周慕白", "叶知秋", "林晚舟"],
    releaseDate: "2026-07-02",
    views: 214300,
    rating: 8.8,
    tags: ["古装", "悬疑", "群像"],
    isFeatured: true,
  },
  {
    id: "variety-happy-journey",
    title: "快乐出发吧",
    category: "variety",
    region: "国内",
    year: 2026,
    cover:
      "https://readdy.ai/api/search-image?query=Colorful%20travel%20reality%20show%20poster%2C%20sunny%20road%20trip%20with%20friends%2C%20warm%20orange%20and%20soft%20cream%20tones%2C%20playful%20flat%20illustration%2C%20energetic%20and%20friendly%20mood%2C%20no%20text&width=600&height=900&seq=mock-variety-01&orientation=portrait",
    summary:
      "六位明星嘉宾自驾穿越山海，在真实旅途中完成挑战任务，笑点与温情并存的下饭综艺。",
    content: [
      "《快乐出发吧》没有复杂的赛制，几位嘉宾只是开着一辆车，沿着海岸线与山区公路一路向北。正是这种不加修饰的松弛感，让它成为许多人饭桌上的固定陪伴。",
      "本季最大的变化是加入了「当地向导」环节。每一站都会有一位本地人带着嘉宾走进日常生活，介绍鲜为人知的美食与手艺，节目因此多了几分纪录的意味。",
      "嘉宾之间的化学反应是节目的灵魂。有人负责搞笑，有人负责操心，也有人负责安静地做饭，这种分工让整季节目的观感自然又舒服。",
    ],
    releaseDate: "2026-05-18",
    views: 98600,
    rating: 8.4,
    tags: ["真人秀", "旅行", "治愈"],
    isFeatured: true,
  },
  {
    id: "movie-long-night",
    title: "长夜将明",
    category: "movie",
    region: "国内",
    year: 2025,
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20noir%20film%20poster%2C%20rainy%20city%20street%20at%20night%2C%20single%20streetlamp%20glow%2C%20deep%20blue%20and%20amber%20contrast%2C%20lonely%20figure%20with%20umbrella%2C%20cinematic%20minimal%20art%2C%20no%20text&width=600&height=900&seq=mock-movie-02&orientation=portrait",
    summary:
      "一场大雨困住了整座城市，也困住了一群各怀秘密的陌生人，写实风格的悬疑群像佳作。",
    content: [
      "影片用一个夜晚、一间二十四小时便利店和一场停不下来的雨，串起了五个彼此陌生却互相关联的人。剧本结构精巧，几乎没有多余的镜头。",
      "摄影是最大加分项。雨夜的霓虹、玻璃上的水痕、便利店冷白色的灯光，被拍出了强烈的氛围感，让观众仿佛真的身处其中。",
      "结尾没有给出标准答案，而是把选择留给了观众。这种克制的处理方式，反而让影片的余韵更长久。",
    ],
    director: "韩立川",
    cast: ["邓一维", "苏浅"],
    releaseDate: "2025-11-08",
    views: 76200,
    rating: 8.6,
    tags: ["悬疑", "写实", "群像"],
  },
  {
    id: "movie-deep-echo",
    title: "深海回响",
    category: "movie",
    region: "国内",
    year: 2025,
    cover:
      "https://readdy.ai/api/search-image?query=Underwater%20mystery%20movie%20poster%2C%20deep%20ocean%20diver%20silhouette%2C%20sunlight%20beams%20through%20turquoise%20water%2C%20mysterious%20wreck%20below%2C%20cinematic%20deep%20blue%20palette%2C%20premium%20editorial%20art%2C%20no%20text&width=600&height=900&seq=mock-movie-03&orientation=portrait",
    summary:
      "一支海洋科考队深入未标注海域，发现的不仅是一艘沉船，更是一段被刻意抹去的往事。",
    content: [
      "《深海回响》把悬念放在水下。导演大量使用自然光与实景拍摄，让海水的层次与压力感透过银幕清晰地传递出来。",
      "故事围绕一支科考队展开。随着下潜深度的增加，队员们彼此之间的信任也在不断被考验。影片把物理上的缺氧与心理上的窒息感叠加在一起。",
      "配乐是本片的另一大亮点。低频的呼吸声与水流声交织，让观众在安静的场景里也能感到紧绷。",
    ],
    director: "何蔚然",
    cast: ["陈砚", "李思瑶", "周拓"],
    releaseDate: "2025-08-22",
    views: 64100,
    rating: 8.2,
    tags: ["冒险", "悬疑", "海洋"],
  },
  {
    id: "movie-city-light",
    title: "城市之光",
    category: "movie",
    region: "国内",
    year: 2024,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20urban%20drama%20poster%2C%20city%20skyline%20at%20dusk%20with%20glowing%20windows%2C%20silhouette%20of%20a%20couple%20on%20a%20rooftop%2C%20orange%20and%20teal%20cinematic%20grading%2C%20soft%20editorial%20illustration%2C%20no%20text&width=600&height=900&seq=mock-movie-04&orientation=portrait",
    summary:
      "两个在都市打拼的年轻人因一盏坏掉的路灯相识，一段关于陪伴与成长的温柔故事。",
    content: [
      "《城市之光》没有惊天动地的情节，它讲述的只是两个普通人如何在偌大的城市里成为彼此的依靠。",
      "导演用大量的空镜记录城市的光影变化，从清晨的地铁到深夜的便利店，把都市生活的节奏拍得细腻而真实。",
      "主演的自然表演是影片的支柱。那些欲言又止的停顿与日常的琐碎对话，恰恰是最动人的部分。",
    ],
    director: "林之遥",
    cast: ["顾南", "白露"],
    releaseDate: "2024-12-01",
    views: 58300,
    rating: 8.0,
    tags: ["爱情", "都市", "治愈"],
  },
  {
    id: "movie-phantom-edge",
    title: "幻境边界",
    category: "movie",
    region: "欧美",
    year: 2026,
    cover:
      "https://readdy.ai/api/search-image?query=Surreal%20sci-fi%20poster%20with%20fragmented%20mirror%20world%2C%20geometric%20portal%2C%20teal%20and%20amber%20glow%2C%20abstract%20digital%20dreamscape%2C%20premium%20editorial%20art%2C%20no%20text&width=600&height=900&seq=mock-movie-05&orientation=portrait",
    summary:
      "当虚拟与现实的边界开始崩坏，一位设计师必须在自己创造的幻境中找回真实的记忆。",
    content: [
      "《幻境边界》是一部关于记忆与真实的作品。影片以一位虚拟世界设计师为主角，探讨当技术能够构建完美世界时，人是否还愿意面对现实。",
      "视觉上，影片在同一场景中无缝切换多种风格，从写实都市到超现实几何空间，展现了极高的美术水准。",
      "故事的核心仍然是人。主角在追寻记忆的过程中逐渐意识到，真正珍贵的从来不是完美，而是那些不完美的真实瞬间。",
    ],
    director: "马丁·科尔",
    cast: ["诺亚·布莱克", "艾拉·福斯特"],
    releaseDate: "2026-03-15",
    views: 88900,
    rating: 8.5,
    tags: ["科幻", "悬疑", "视觉"],
  },
  {
    id: "tv-urban-days",
    title: "都市浮生记",
    category: "tv",
    region: "国内",
    year: 2025,
    cover:
      "https://readdy.ai/api/search-image?query=Contemporary%20urban%20drama%20poster%2C%20busy%20city%20office%20scene%2C%20muted%20navy%20and%20cream%20tones%2C%20minimal%20editorial%20illustration%2C%20subtle%20warm%20light%2C%20no%20text&width=600&height=900&seq=mock-tv-02&orientation=portrait",
    summary:
      "聚焦三组普通家庭的都市群像剧，真实描摹职场、亲情与理想之间的拉扯。",
    content: [
      "《都市浮生记》把镜头对准了三组生活在同一栋楼里的家庭。他们背景各异，却都在为生活奔波。",
      "编剧擅长在日常细节中埋下冲突的种子。一次聚餐、一通电话、一份迟到的账单，都可能成为人物关系的转折点。",
      "剧集没有刻意制造戏剧性，而是让情节自然生长。这种真实感，让许多观众在角色身上看到了自己的影子。",
    ],
    director: "赵清和",
    cast: ["秦岚", "周正", "苏小满"],
    releaseDate: "2025-09-10",
    views: 112400,
    rating: 8.3,
    tags: ["都市", "家庭", "群像"],
  },
  {
    id: "tv-mountain-legend",
    title: "山河故人传",
    category: "tv",
    region: "国内",
    year: 2025,
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20historical%20drama%20poster%2C%20misty%20mountains%20and%20ancient%20battle%20standard%2C%20deep%20jade%20and%20gold%20tones%2C%20lone%20warrior%20silhouette%2C%20cinematic%20editorial%20art%2C%20no%20text&width=600&height=900&seq=mock-tv-03&orientation=portrait",
    summary:
      "跨越三十年的家族史诗，讲一代人在时代变迁中的坚守与抉择，厚重而动人。",
    content: [
      "《山河故人传》以一条河、一座桥、三代人为线索，讲述了一个家族在时代变迁中的故事。",
      "剧集的时间跨度长达三十年，服化道与场景随年代自然变化，细节考究，让观众能清晰地感受到时间流逝。",
      "最难得的是本剧对历史的尊重。它没有简单地评判对错，而是把人物的选择放回具体的处境中去理解。",
    ],
    director: "郑之远",
    cast: ["王建国", "刘素梅", "江远"],
    releaseDate: "2025-04-06",
    views: 137900,
    rating: 8.9,
    tags: ["年代", "家庭", "史诗"],
  },
  {
    id: "tv-mist-track",
    title: "迷雾追踪",
    category: "tv",
    region: "日韩",
    year: 2026,
    cover:
      "https://readdy.ai/api/search-image?query=Crime%20thriller%20poster%20with%20foggy%20street%20and%20faint%20blue%20light%2C%20mysterious%20figure%20under%20a%20lamp%2C%20dark%20teal%20and%20amber%20contrast%2C%20tense%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=mock-tv-04&orientation=portrait",
    summary:
      "一起尘封多年的旧案重新浮出水面，两名立场不同的警察被迫联手追凶。",
    content: [
      "《迷雾追踪》的叙事节奏紧凑，前两集便抛出多个疑点，让观众迅速进入追剧状态。",
      "两位主角的设计颇具张力：一个相信程序，一个相信直觉。他们在合作中不断碰撞，也在碰撞中逐渐互补。",
      "剧集对犯罪背后社会议题的探讨并不过火，点到为止，把更多空间留给了人物本身的挣扎。",
    ],
    director: "金敏浩",
    cast: ["李准基", "朴秀贤"],
    releaseDate: "2026-02-14",
    views: 104700,
    rating: 8.4,
    tags: ["悬疑", "犯罪", "双雄"],
  },
  {
    id: "tv-time-relic",
    title: "时光拾遗",
    category: "tv",
    region: "国内",
    year: 2024,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20drama%20poster%2C%20old%20camera%20and%20letters%20on%20wooden%20desk%2C%20soft%20sepia%20and%20cream%20tones%2C%20gentle%20afternoon%20light%2C%20editorial%20interior%20art%2C%20no%20text&width=600&height=900&seq=mock-tv-05&orientation=portrait",
    summary:
      "一位修复师在整理老物件时，意外拼凑出一段被遗忘的青春故事，温暖治愈。",
    content: [
      "《时光拾遗》像一杯温热的茶，节奏缓慢却不乏味。故事围绕一件件老物件的修复展开，每件物品背后都有一段人生。",
      "剧集的美术极其用心，工作室里的工具、泛黄的照片、磨损的信纸，都透着岁月的质感。",
      "它想表达的其实很简单：在快速向前的时代里，仍然值得停下来，认真对待那些看似无用的旧物与旧情。",
    ],
    director: "程雨",
    cast: ["沈书", "陆遥"],
    releaseDate: "2024-10-20",
    views: 69400,
    rating: 8.1,
    tags: ["治愈", "年代", "温情"],
  },
  {
    id: "variety-music-rhapsody",
    title: "音乐狂想曲",
    category: "variety",
    region: "国内",
    year: 2026,
    cover:
      "https://readdy.ai/api/search-image?query=Vibrant%20music%20competition%20show%20poster%2C%20abstract%20sound%20waves%20and%20stage%20lighting%2C%20warm%20orange%20purple%20gradient%20glow%2C%20dynamic%20energetic%20flat%20illustration%2C%20no%20text&width=600&height=900&seq=mock-variety-02&orientation=portrait",
    summary:
      "不同风格的音乐人同台竞演，用作品对话，一场关于声音与态度的舞台盛宴。",
    content: [
      "《音乐狂想曲》不做简单的翻唱比拼，而是要求每位音乐人在限定主题下完成原创或改编，真正考验创作能力。",
      "节目组把舞台设计得非常克制，让观众的注意力回到音乐本身。灯光随情绪变化，却从不喧宾夺主。",
      "嘉宾之间的惺惺相惜是本季的亮点。竞争之外，更多的是同行之间的尊重与启发。",
    ],
    releaseDate: "2026-04-11",
    views: 85300,
    rating: 8.5,
    tags: ["音乐", "竞演", "舞台"],
  },
  {
    id: "variety-talk-night",
    title: "脱口秀之夜",
    category: "variety",
    region: "国内",
    year: 2025,
    cover:
      "https://readdy.ai/api/search-image?query=Stand-up%20comedy%20show%20poster%2C%20microphone%20and%20spotlight%20on%20a%20small%20stage%2C%20warm%20amber%20and%20deep%20navy%20tones%2C%20playful%20minimal%20illustration%2C%20no%20text&width=600&height=900&seq=mock-variety-03&orientation=portrait",
    summary:
      "一群讲段子的年轻人，用幽默解构生活，笑声背后是真诚的观察与表达。",
    content: [
      "《脱口秀之夜》把舞台留给了普通人。他们讲述的段子大多来自真实生活，关于工作、家庭、房租与梦想。",
      "节目最大的价值在于它提供了一个表达的空间。笑声之后，观众往往会想起自己的某段经历。",
      "本季的赛制更加宽松，鼓励新人尝试。有几匹黑马的表现让人惊喜，也让节目保持了新鲜感。",
    ],
    releaseDate: "2025-07-19",
    views: 91800,
    rating: 8.6,
    tags: ["脱口秀", "喜剧", "生活"],
  },
  {
    id: "variety-dream-trip",
    title: "向往的旅程",
    category: "variety",
    region: "国内",
    year: 2025,
    cover:
      "https://readdy.ai/api/search-image?query=Slow%20living%20lifestyle%20show%20poster%2C%20cozy%20farmhouse%20with%20vegetable%20garden%2C%20soft%20green%20and%20cream%20tones%2C%20peaceful%20warm%20illustration%2C%20no%20text&width=600&height=900&seq=mock-variety-04&orientation=portrait",
    summary:
      "嘉宾远离城市，在乡野间种菜做饭、招待客人，慢节奏的田园治愈生活。",
    content: [
      "《向往的旅程》几乎没有什么任务设定，嘉宾每天做的就是做饭、聊天、招待来往的朋友。",
      "正是这种朴素，构成了节目最大的吸引力。镜头里的炊烟、菜园和远山，让人不自觉放松下来。",
      "每期到访的客人都各有故事。他们与常驻嘉宾的对话，往往在不经意间说出打动人心的句子。",
    ],
    releaseDate: "2025-03-08",
    views: 77500,
    rating: 8.2,
    tags: ["慢综艺", "田园", "治愈"],
  },
  {
    id: "variety-food-adventure",
    title: "美食奇遇记",
    category: "variety",
    region: "国内",
    year: 2024,
    cover:
      "https://readdy.ai/api/search-image?query=Food%20travel%20show%20poster%2C%20steaming%20bowls%20on%20a%20market%20stall%2C%20warm%20red%20and%20cream%20tones%2C%20appetizing%20flat%20illustration%2C%20cozy%20street%20food%20mood%2C%20no%20text&width=600&height=900&seq=mock-variety-05&orientation=portrait",
    summary:
      "跟着主持人走街串巷，寻访藏在市井里的地道风味，一碗一筷皆是人间烟火。",
    content: [
      "《美食奇遇记》走的是脚踏实地的路线。摄制组不追求名店，而是钻进菜市场和老巷子，寻找最普通的家常味。",
      "主持人几乎不摆拍，吃完饭还会和摊主聊上几句。这种真实感，让节目比许多美食纪录片更亲切。",
      "每一集的结尾都会介绍一位摊主的小故事。他们守着一个小摊几十年，构成了城市味觉记忆的一部分。",
    ],
    releaseDate: "2024-11-16",
    views: 70200,
    rating: 8.0,
    tags: ["美食", "纪实", "烟火气"],
  },
  {
    id: "movie-hometown-cloud",
    title: "故乡的云",
    category: "movie",
    region: "日韩",
    year: 2025,
    cover:
      "https://readdy.ai/api/search-image?query=Gentle%20family%20drama%20poster%2C%20rural%20landscape%20with%20clouds%2C%20small%20house%20by%20rice%20fields%2C%20soft%20green%20and%20cream%20palette%2C%20nostalgic%20cinematic%20art%2C%20no%20text&width=600&height=900&seq=mock-movie-06&orientation=portrait",
    summary:
      "一位中年男人回到阔别多年的故乡，与年迈的母亲重新相处，静水流深的亲情故事。",
    content: [
      "《故乡的云》节奏很慢，却慢得恰到好处。影片用大量自然光与长镜头，记录了一个男人与母亲重新建立联系的夏天。",
      "对白极少，很多情绪通过动作与沉默传达。一次一起吃饭，一次并肩散步，胜过千言万语。",
      "影片让人想起自己的家人。走出影院时，许多人做的第一件事，是给家里打了一个电话。",
    ],
    director: "佐藤健一",
    cast: ["山田凉介", "中野惠子"],
    releaseDate: "2025-05-30",
    views: 55900,
    rating: 8.7,
    tags: ["家庭", "剧情", "治愈"],
  },
  {
    id: "tv-star-rain",
    title: "星河之约",
    category: "tv",
    region: "国内",
    year: 2026,
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20fantasy%20drama%20poster%2C%20starry%20night%20sky%20with%20shooting%20stars%2C%20two%20figures%20on%20a%20hill%2C%20deep%20blue%20and%20soft%20gold%20tones%2C%20dreamy%20editorial%20art%2C%20no%20text&width=600&height=900&seq=mock-tv-06&orientation=portrait",
    summary:
      "天文台里的两个年轻研究员，因为一颗流星相遇，也因为各自的理想走上不同的道路。",
    content: [
      "《星河之约》表面上是一个爱情故事，内核却是关于理想与选择的成长叙事。",
      "剧中大量的天文观测场景拍得浪漫又严谨，让观众在情感之外，也认识了不少星空常识。",
      "两位主角的感情线克制而真诚。他们没有轰轰烈烈的告白，更多的是并肩仰望星空的默契。",
    ],
    director: "顾清言",
    cast: ["许星辰", "沈知夏"],
    releaseDate: "2026-01-24",
    views: 96100,
    rating: 8.3,
    tags: ["爱情", "成长", "青春"],
  },
  {
    id: "variety-stage-king",
    title: "舞台之王",
    category: "variety",
    region: "国内",
    year: 2026,
    cover:
      "https://readdy.ai/api/search-image?query=Stage%20performance%20competition%20poster%2C%20dramatic%20spotlight%20beams%20and%20theater%20curtains%2C%20rich%20burgundy%20and%20gold%20tones%2C%20elegant%20minimal%20illustration%2C%20no%20text&width=600&height=900&seq=mock-variety-06&orientation=portrait",
    summary:
      "来自各地的表演团队同台切磋，用舞蹈、戏剧与音乐，争夺年度舞台之王的荣誉。",
    content: [
      "《舞台之王》把注意力放在表演团队的协作上。每一场演出都需要数十人的默契配合，难度远超个人竞演。",
      "节目组邀请了多位业内前辈担任评审，他们的点评专业且中肯，让节目兼具观赏性与学习价值。",
      "舞台呈现水准极高。从灯光调度到服化设计，每一场都像是浓缩的小型演出，让人看得过瘾。",
    ],
    releaseDate: "2026-06-28",
    views: 82400,
    rating: 8.4,
    tags: ["舞蹈", "竞演", "舞台"],
  },
  {
    id: "movie-silent-confession",
    title: "无声告白",
    category: "movie",
    region: "欧美",
    year: 2024,
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20emotional%20drama%20poster%2C%20window%20with%20rain%20and%20a%20chair%20by%20it%2C%20muted%20grey%20and%20soft%20amber%20light%2C%20minimal%20melancholic%20editorial%20art%2C%20no%20text&width=600&height=900&seq=mock-movie-07&orientation=portrait",
    summary:
      "一封从未寄出的信，揭开了一段埋藏二十年的情感，关于错过与和解的细腻之作。",
    content: [
      "《无声告白》用一个安静的空间和极少的人物，撑起了一段跨越二十年的情感。",
      "影片的叙事在现在与回忆之间来回切换，节奏平稳，情绪却在不知不觉中累积。",
      "结尾的处理尤其出色。没有煽情的对白，只有一个简单的动作，却让整部影片的情感找到了出口。",
    ],
    director: "克莱尔·摩根",
    cast: ["汤姆·哈迪", "艾米莉·布朗"],
    releaseDate: "2024-09-12",
    views: 49700,
    rating: 8.2,
    tags: ["剧情", "情感", "文艺"],
  },
  {
    id: "tv-dawn-border",
    title: "黎明边境",
    category: "tv",
    region: "欧美",
    year: 2026,
    cover:
      "https://readdy.ai/api/search-image?query=Frontier%20adventure%20series%20poster%2C%20vast%20desert%20canyon%20at%20sunrise%2C%20lone%20rider%20silhouette%2C%20warm%20amber%20and%20dusty%20blue%20palette%2C%20epic%20cinematic%20art%2C%20no%20text&width=600&height=900&seq=mock-tv-07&orientation=portrait",
    summary:
      "在荒凉边境小镇，一名治安官要面对来自各方势力的博弈，西部气质与人性挣扎并存。",
    content: [
      "《黎明边境》把故事放在一片广袤而贫瘠的边境之地，小镇虽小，却聚集了形形色色的人。",
      "剧集对白精彩，许多对话既是交锋也是试探，信息量大却不显啰嗦，很考验编剧功力。",
      "美术与取景极其出色。日出时分的沙丘与峡谷，几乎每一帧都可以截图收藏。",
    ],
    director: "詹姆斯·洛克",
    cast: ["卢卡斯·格兰特", "诺拉·雷耶斯"],
    releaseDate: "2026-07-30",
    views: 74300,
    rating: 8.6,
    tags: ["西部", "冒险", "剧情"],
  },
  {
    id: "movie-wind-luoyang",
    title: "风起洛阳",
    category: "movie",
    region: "国内",
    year: 2026,
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20epic%20movie%20poster%2C%20grand%20city%20gate%20and%20flying%20banners%2C%20warm%20gold%20and%20deep%20red%20tones%2C%20dramatic%20clouds%2C%20refined%20cinematic%20art%2C%20no%20text&width=600&height=900&seq=mock-movie-08&orientation=portrait",
    summary:
      "一桩发生在神都的奇案，牵出朝堂与江湖的双重暗线，古装悬疑的野心之作。",
    content: [
      "《风起洛阳》的格局很大，它没有止步于一桩案子，而是借由案件描绘出一整座城市的运转与呼吸。",
      "影片的动作设计干脆利落，几场追逐戏调度精准，兼顾了观赏性与紧张感。",
      "美术团队重建了神都的街巷与市井，细节之丰富，让观众仿佛真的穿越回了那个时代。",
    ],
    director: "徐承志",
    cast: ["萧然", "温之言", "柳如烟"],
    releaseDate: "2026-05-06",
    views: 118200,
    rating: 8.5,
    tags: ["古装", "悬疑", "动作"],
  },
];